import { render } from "./ClassesStudentsOverdue.vue?vue&type=template&id=5fa1e22c&scoped=true"
import script from "./ClassesStudentsOverdue.vue?vue&type=script&lang=js"
export * from "./ClassesStudentsOverdue.vue?vue&type=script&lang=js"

import "./ClassesStudentsOverdue.vue?vue&type=style&index=0&id=5fa1e22c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa1e22c"]])

export default __exports__